import React, { FunctionComponent, PropsWithChildren } from 'react';
import DataPluginParameterField from './DataPluginParameterField';

//
// A generic component to collect and validate the name of an instance of an entity.
//

const EntityName: FunctionComponent<any> = (props: PropsWithChildren<any>) => {
    const {
        handleNameChange,
        instanceName,
        fieldName = 'name',
        fieldLabel = 'Name'
    } = props;

    return (
        <DataPluginParameterField
            fieldId="entityName"
            className="entity-name-input"
            currentValue={instanceName}
            setting={{ label: fieldLabel, name: fieldName, required: true }}
            handleSettingsChange={handleNameChange}
            error={props.error}
        />
    );
};

export default EntityName;
